import { Timestamp } from '@angular/fire/firestore';

/** `type` field on observation `data/api/{docId}` documents created by stock init. */
export const STOCK_INIT_OBSERVATION_API_TYPE = 'STOCK_INIT';

/** Status written by the stock init observation document. */
export type IStockInitObservationStatus = 'PROCESSING' | 'SUCCESS' | 'FAILED';

/**
 * UI-facing sync status for the stock take dashboard.
 */
export type ILastStockTakeSyncStatus = 'NOT_SYNCED' | 'PENDING' | 'SUCCESS' | 'FAILED';

/** Firestore field names on STOCK_INIT observation documents (camelCase). */
export const STOCK_INIT_FIELD_ITEMS_INITIALIZED = 'itemsInitialized';
export const STOCK_INIT_FIELD_TOTAL_ITEMS = 'totalItems';
export const STOCK_INIT_FIELD_EXECUTED_AT = 'executedAt';
export const STOCK_INIT_FIELD_COMPLETED_AT = 'completedAt';

/**
 * Observation document at `observation/stores_data/{storeId}/data/api/stock_init`
 * (doc id may vary for legacy runs). Property names match Firestore camelCase fields.
 */
export interface IStockInitObservationDoc {
  status: IStockInitObservationStatus;
  type: typeof STOCK_INIT_OBSERVATION_API_TYPE;
  completedAt?: Timestamp;
  error?: string | null;
  executedAt?: Timestamp;
  /** Progress counter — Firestore `itemsInitialized`. */
  itemsInitialized?: number;
  /** Total stock docs to process — Firestore `totalItems`. */
  totalItems?: number;
}

/** @deprecated Use STOCK_INIT_OBSERVATION_API_TYPE */
export const STOCK_TAKE_DATE_SYNC_API_TYPE = STOCK_INIT_OBSERVATION_API_TYPE;

/** @deprecated Use IStockInitObservationDoc */
export type IStockTakeDateSyncDoc = IStockInitObservationDoc;

/** @deprecated Use IStockInitObservationStatus */
export type IStockTakeDateSyncStatus = IStockInitObservationStatus;
